import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Alert, { type AlertProps } from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import IconButton from '@mui/material/IconButton';

export interface ToastProps {
  content: React.ReactNode | string;
  onClose: () => void;
  title?: React.ReactNode | string;
  type: AlertProps['severity'];
  autoHideDuration?: number;
}

export const Toast = React.forwardRef<HTMLDivElement, ToastProps>(
  (props, ref) => {
    const { content, onClose, title, type } = props;
    const color = `${type}.dark`;

    return (
      <Alert
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            onClick={onClose}
            sx={{ p: 0.5 }}
          >
            <CloseIcon />
          </IconButton>
        }
        ref={ref}
        severity={type}
        sx={{ width: '100%', color }}
      >
        {title && <AlertTitle sx={{ color }}>{title}</AlertTitle>}
        {content}
      </Alert>
    );
  }
);
